import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ArticleComponent } from '../article/article.component';
import { HeaderModalComponent } from '../header-modal/header-modal.component';
import { CustomModalController } from '../../../shared/services/custom-modal-controller.service';
import { ArticleComponentData } from '../../../types/material.interface';

@Component({
  selector: 'app-article-modal',
  standalone: true,
  imports: [CommonModule, IonicModule, ArticleComponent, HeaderModalComponent],
  templateUrl: './article-modal.component.html',
  styleUrls: ['./article-modal.component.scss']
})
export class ArticleModalComponent {
  private modalCtrl = inject(CustomModalController);

  @Input() title: string = '';
  @Input() content: ArticleComponentData[] = [];
  @Input() showAcceptButton: boolean = true;
  @Input() acceptButtonText: string = 'Acepto';
  
  @Output() accepted = new EventEmitter<void>();
  @Output() buttonClicked = new EventEmitter<{ action?: string; index: number }>();

  dismiss(): void {
    this.modalCtrl.dismiss();
  }

  onAccept(): void {
    this.accepted.emit();
    this.modalCtrl.dismiss({ accepted: true }, 'accepted');
  }

  onButtonClick(event: { action?: string; index: number }): void {
    this.buttonClicked.emit(event);
    // If action is 'accept', treat it like the accept button
    if (event.action === 'accept') {
      this.onAccept();
    }
  }
}
